import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { XIcon } from "@heroicons/react/outline";
import axios from "axios";
import Button from "../../../../../components/buttons/buttons";
import Input from "../../../../../components/inputs/inputs";
import Location from "../../../../../components/includes/location";
import LocationSearch from "../../../../../components/includes/locationSearch";
import { Beat } from "../../../../../plugins/spinners.plugin";
import { ImageCropModal } from "../../../../../components/modals/imageCropModal";
import SelectableInput from "../../../../../components/inputs/SelectableInput";
import { cleanInput } from "../../../../../helpers/cleanInput";
import {
  getOutletFromCookies,
  getToken,
  getTeamFromCookies,
} from "../../../../../utils/Auth";
import { getSingleStore } from "../../../../../redux/stores/storeActions";
import { filterProductCategory } from "../../../../../redux/productCatergory/productCategoryAction";
import { getAllTags } from "../../../../../redux/productTags/productTagActions";
import successHandler from "../../../../../handlers/successHandler";
import errorHandler from "../../../../../handlers/errorHandler";

export default function EditStoreInformation() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const outlet = getOutletFromCookies();
  const hiddenFileInput = useRef(null);
  const hiddenBannerInput = useRef(null);

  const { singleStore, updating } = useSelector((state) => state.store);
  const { allCategories } = useSelector((state) => state.productCatergory);
  const { allTags } = useSelector((state) => state.productTag);
  const { settings } = useSelector((state) => state.application);
  const useGooglePlaces = settings?.google_places_status === "available";

  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageUrls, setImageUrls] = useState([]);
  const [image64, setImage64] = useState({});
  const [displayCropImage, setDisplayCropImage] = useState(false);
  const [displayCropBanner, setDisplayCropBanner] = useState(false);
  const [cropSourceImageFiles, setCropSourceImageFiles] = useState([]);
  const [cropSourceBannerFiles, setCropSourceBannerFiles] = useState([]);

  const [input, setInput] = useState({
    id: outlet?.id,
    business_id: outlet?.business_id,
    store_email: singleStore?.store_email,
    store_name: singleStore?.store_name,
    store_phone: singleStore?.store_phone,
    store_address: singleStore?.store_address,
    store_description: singleStore?.store_description,
    store_categories: singleStore?.store_categories,
    store_tags: singleStore?.store_tags,
    store_city: singleStore?.store_city,
    store_country: singleStore?.store_country,
    store_state: singleStore?.store_state,
    store_operating_status: singleStore?.store_operating_status,
    url_photos: singleStore?.store_pictures || [],
  });
  const {
    store_email,
    store_name,
    store_phone,
    store_address,
    store_description,
    store_categories,
    store_tags,
    store_country,
    store_state,
    store_city,
    store_operating_status,
  } = input;
  //This is used to get the list of region data ie: country, city and states
  const [locationId, setLocationId] = React.useState({
    country_id: "",
    state_id: "",
    city_id: "",
  });
  const [locationList, setLocationList] = React.useState({
    countryList: [],
    stateList: [],
    cityList: [],
  });
  const toJson = (value) => JSON.stringify(value);
  const fromJson = (value) => JSON.parse(value);

  useEffect(() => {
    dispatch(getSingleStore(outlet?.id));
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch(getAllTags());
    dispatch(filterProductCategory({ type: "store" }, 1));
    // eslint-disable-next-line
  }, []);

  const storeCategories = allCategories?.data?.filter((item) => {
    return item?.type === "store";
  });
  const storeTags = allTags?.data?.filter((item) => {
    return item?.type === "store";
  });

  function handleRegion(e) {
    const { name, value } = e.target;
    setInput((input) => ({ ...input, [name]: fromJson(value).name }));
  }

  //This is used to set location if google places is active
  const handleSelectLocation = (place) => {
    setInput((prev) => ({
      ...prev,
      store_address: place.address,
      store_city: place.city,
      store_state: place.state,
      store_country: place.country,
      store_latitude: place.lat,
      store_longitude: place.lng,
      store_zip: place.postalCode,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleAddTags = (value) => {
    let former_tags = [];
    if (input?.store_tags) {
      former_tags = [...input?.store_tags];
    } else {
      former_tags = [];
    }
    let new_tags = [...former_tags, value.name];
    setInput({ ...input, store_tags: new_tags });
  };
  const handleAddCategories = (value) => {
    const former_categories = [...input?.store_categories];
    let new_categories = [...former_categories, value.name];
    setInput({ ...input, store_categories: new_categories });
  };

  const handleStorePhone = (e) => {
    let store_phone = e?.slice(1);
    setInput({ ...input, store_phone: store_phone });
  };
  function onImageChange(e) {
    const newFiles = Array.from(e.target.files);
    setCropSourceImageFiles(newFiles);
    setImages([...images, ...e.target.files]);
    setDisplayCropImage(true);
  }
  const handleFileClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };
  const removeFile = (index) => {
    let newArr = images;
    newArr.splice(index, 1);
    setImages([...newArr]);
  };

  const removeUrlPhoto = (index) => {
    let newArr = [...input?.url_photos];
    newArr.splice(index, 1);
    setInput({ ...input, url_photos: newArr });
  };

  useEffect(() => {
    const newImageUrls = [];
    const newImage64 = [];
    images?.forEach((image) => {
      newImageUrls.push(URL.createObjectURL(image));
      let reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onloadend = () => {
        newImage64.push(reader.result);
      };
    });
    setImageUrls(newImageUrls);
    setImage64(newImage64);
  }, [images]);

  const [bannerArray, setBannerArray] = useState([]);
  const [bannersUrl, setBannersUrl] = useState([]);

  const handleBannerClick = (event) => {
    event.preventDefault();
    hiddenBannerInput.current.click();
  };
  const onBannerChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setCropSourceBannerFiles(newFiles);
    setBannerArray([...e.target.files]);
    setDisplayCropBanner(true);
  };

  useEffect(() => {
    if (bannerArray.length < 1) return;
    const newImageUrls = [];
    bannerArray.forEach((image) =>
      newImageUrls.push(URL.createObjectURL(image))
    );
    setBannersUrl(newImageUrls);
  }, [bannerArray]);

  const closeCropImage = () => {
    setDisplayCropImage(false);
  };

  const closeCropBanner = () => {
    setDisplayCropBanner(false);
  };

  const handleSubmit = async () => {
    let newInput = {
      ...input,
      base64_photos: image64 ? image64 : [],
      banners: bannerArray ? bannerArray : [],
    };
    cleanInput(newInput);
    setLoading(true);
    axios
      .post("https://server.food.test.ogwugo.xyz/api/store/update", newInput, {
        headers: {
          accept: "application/json",
          "Accept-Language": "en-US,en;q=0.8",
          "Content-Type": `multipart/form-data;`,
          Authorization: `Bearer ${getToken()}`,
          Team: `${getTeamFromCookies()}`,
        },
      })
      .then((response) => {
        setLoading(false);
        successHandler(response, true);
        navigate(`/admin/$${outlet?.store_name}/settings/store`);
      })
      .catch((error) => {
        //handle error
        setLoading(false);
        errorHandler(error, true);
      });
  };

  return (
    <div data-test="openingHours-page">
      <div className="bg-white dark:bg-[#121212] border dark:border-none w-full px-4 sm:px-6 sm:max-w-6xl mx-auto py-4 mt-8">
        <p>
          Manage your store details, make changes to your store details here.
        </p>
      </div>
      <div className="pt-8 justify-center items-center  mx-auto sm:max-w-6xl">
        <div className=" p-5 w-full bg-white dark:bg-[#121212] rounded-sm border dark:border-none sm:p-8  ">
          <div className="flex justify-between items-center my-4">
            <h3 className="text-base text-gray-500 dark:text-white font-meduim flex justify-center mb-0">
              Store Information
            </h3>
          </div>

          <div className="border-b mb-8"></div>

          <form className="w-full">
            <Input.Label
              title={"Store Name"}
              type="text"
              name="store_name"
              id="store_name"
              defaultValue={store_name}
              className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
              placeholder="Enter store Name"
              onChange={handleChange}
            />
            <Input.Label
              title={"Store Email"}
              type="email"
              name="store_email"
              id="store_email"
              defaultValue={store_email}
              className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
              placeholder="Enter store email"
              onChange={handleChange}
            />
            <Input.Phone
              title={"Store Phone Number"}
              name={"store_phone"}
              id={"store_phone"}
              defaultCountry={"NG"}
              value={store_phone}
              htmlFor={"store_phone"}
              className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
              onChange={handleStorePhone}
            />
            <Input.Label
              title={"Store Description"}
              type="text"
              name="store_description"
              id="store_description"
              defaultValue={store_description}
              className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
              placeholder="Enter store description"
              onChange={handleChange}
            />
            <Input.Select
              title={"Store Status"}
              type="text"
              name="store_operating_status"
              id="store_operating_status"
              value={store_operating_status}
              className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
              onChange={handleChange}
            >
              <option value={"open"}>Open</option>
              <option value={"closed"}>Closed</option>
            </Input.Select>
            <div className="mb-4">
              <label
                htmlFor="store_categories"
                className="text-sm font-medium text-[#151515] dark:text-white mb-1"
              >
                Store Categories
              </label>
              <SelectableInput
                options={storeCategories}
                label="store_categories"
                name={"+ Add Category"}
                type="category"
                previousSelected={store_categories}
                selectOption={handleAddCategories}
              />
            </div>
            <div className="mb-4">
              <label
                htmlFor="store_tags"
                className="text-sm font-medium text-[#151515] dark:text-white mb-1"
              >
                Store Tags
              </label>
              <SelectableInput
                options={storeTags}
                label="store_tags"
                name={"+ Add Tag"}
                type="tag"
                previousSelected={store_tags}
                selectOption={handleAddTags}
              />
            </div>

            <Location
              country_id={locationId.country_id}
              state_id={locationId.state_id}
              city_id={locationId.city_id}
              countryList={(value) => {
                setLocationList({
                  ...locationList,
                  countryList: value,
                });
              }}
              stateList={(value) => {
                setLocationList({
                  ...locationList,
                  stateList: value,
                });
              }}
              cityList={(value) => {
                setLocationList({ ...locationList, cityList: value });
              }}
            />

            {/* Google Places or Manual Address */}
            {useGooglePlaces ? (
              <div className="my-4">
                <LocationSearch
                  onPlaceSelect={handleSelectLocation}
                  searchLocationTitle={"Search Store Location*"}
                  defaultAddress={store_address}
                  defaultAddressTitle={"Store Address"}
                />
              </div>
            ) : (
              <Input.Label
                title={"Store Address"}
                type="text"
                name="store_address"
                id="store_address"
                defaultValue={store_address}
                className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                placeholder="Enter store Address"
                onChange={handleChange}
              />
            )}
             <div className={useGooglePlaces ? "hidden" : ""}>
              <div className="mt-6">
                <Input.Select
                  title={"Select Country"}
                  name="country"
                  id="country"
                  disabled={useGooglePlaces}
                  value={store_country}
                  className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                  htmlFor={"country"}
                  onChange={(e) => {
                    setLocationId({
                      ...locationId,
                      country_id: fromJson(e.target.value).id,
                    });
                    handleRegion(e);
                  }}
                >
                  <option>{store_country ?? "Select Country"}</option>
                  {locationList.countryList &&
                    locationList.countryList.length > 0 &&
                    locationList.countryList.map((item, key) => {
                      return (
                        <option
                          key={key}
                          value={toJson({
                            name: item.name,
                            id: item.id,
                          })}
                        >
                          {item.name}
                        </option>
                      );
                    })}
                </Input.Select>
              </div>
              <div className="mt-6">
                <Input.Select
                  title={"Select State"}
                  name="state"
                  id="state"
                  disabled={useGooglePlaces}
                  value={store_state}
                  className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                  htmlFor={"state"}
                  onChange={(e) => {
                    setLocationId({
                      ...locationId,
                      state_id: fromJson(e.target.value).id,
                    });
                    handleRegion(e);
                  }}
                >
                  <option>{store_state ?? "Select State"}</option>
                  {locationList.stateList &&
                    locationList.stateList.length > 0 &&
                    locationList.stateList.map((item, key) => {
                      return (
                        <option
                          key={key}
                          value={toJson({
                            name: item.name,
                            id: item.id,
                          })}
                        >
                          {item.name}
                        </option>
                      );
                    })}
                </Input.Select>
              </div>
              <div className="mt-6">
                <Input.Select
                  title={"Select City"}
                  name="city"
                  id="city"
                  disabled={useGooglePlaces}
                  value={store_city}
                  className="w-full border border-[#E4E4F3] focus-within:border-primary focus:border-primary focus:ring-0 sm:text-sm"
                  htmlFor={"city"}
                  onChange={(e) => {
                    setLocationId({
                      ...locationId,
                      city_id: fromJson(e.target.value).id,
                    });
                    handleRegion(e);
                  }}
                >
                  <option>{store_city ?? "Select City"}</option>
                  {locationList.cityList &&
                    locationList.cityList.length > 0 &&
                    locationList.cityList.map((item, key) => {
                      return (
                        <option
                          key={key}
                          value={toJson({
                            name: item.name,
                            id: item.id,
                          })}
                        >
                          {item.name}
                        </option>
                      );
                    })}
                </Input.Select>
              </div>
              <div className="grid sm:grid-cols-2 gap-1 sm:gap-8 mt-6">
                <Input.Label
                  title={"Latitude"}
                  name="store_latitude"
                  id="store_latitude"
                  disabled={useGooglePlaces}
                  value={singleStore?.store_latitude}
                  className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                  placeholder="Enter latitude"
                  onChange={handleChange}
                />

                <Input.Label
                  title={"Longitude"}
                  name="store_longitude"
                  id="store_longitude"
                  disabled={useGooglePlaces}
                  value={singleStore?.store_longitude}
                  className="w-full border border-[#E4E4F3] focus:border-primary focus:ring-0 sm:text-sm"
                  placeholder="Enter longitude"
                  onChange={handleChange}
                />
              </div>
            </div>
          </form>
        </div>


        <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-8 mt-8">
          <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
            <div>
              <h3 className="text-lg font-medium">
                Store Images (200px by 200px)
              </h3>
            </div>
            <>
              <button className="text-primary" onClick={handleFileClick}>
                + Upload Image
              </button>
              <input
                type="file"
                className="hidden"
                accept="image/*"
                onChange={onImageChange}
                ref={hiddenFileInput}
              />
            </>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-6 gap-8 mt-8">
            {input?.url_photos?.length > 0 &&
              input?.url_photos?.map((image, index) => (
                <figure className="w-full h-[160px] relative" key={index}>
                  <img
                    src={image}
                    className="object-cover w-full h-full"
                    alt="food"
                  />
                  <button
                    className="h-8 w-8 bg-[#FAE9E6] rounded-full absolute right-2 top-2"
                    onClick={() => removeUrlPhoto(index)}
                  >
                    <XIcon className="h-5 w-5 text-primary mx-auto" />
                  </button>
                </figure>
              ))}

            {imageUrls?.length > 0
              ? imageUrls?.map((image, index) => (
                <figure className="w-full h-[160px] relative" key={index}>
                  <img
                    src={image}
                    className="w-[160px] h-[160px] object-cover"
                    alt="merchandise"
                  />
                  <button
                    className="h-8 w-8 bg-[#FAE9E6] rounded-full absolute right-2 top-2"
                    onClick={() => removeFile(index)}
                  >
                    <XIcon className="h-5 w-5 text-primary mx-auto" />
                  </button>
                </figure>
              ))
              : ""}
          </div>
        </div>
        <div className="border border-[#E4E4F3] dark:border-none bg-white dark:bg-[#121212] rounded-md py-5 px-8 mt-8">
          <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
            <div>
              <h3 className="text-lg font-medium">
                Store Banner (1440px by 576px)
              </h3>
            </div>
            <>
              <button className="text-primary" onClick={handleBannerClick}>
                + Upload Banner
              </button>
              <input
                type="file"
                className="hidden"
                accept="image/*"
                onChange={onBannerChange}
                ref={hiddenBannerInput}
              />
            </>
          </div>

          {/* <div className="grid grid-cols-1  gap-8 mt-8">
            {singleStore?.store_banners?.length > 0 ? (
              singleStore?.store_banners.map((image, index) => (
                <figure className="w-full h-[200px] relative" key={index}>
                  <img
                    src={image}
                    className="object-cover w-full h-full"
                    alt="merchandise"
                  />
                </figure>
              ))
            ) : (
              <p>No banners uploaded. Edit store to add Images</p>
            )}
          </div> */}
          <div className="mt-8">
            {bannersUrl?.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-6 gap-8">
                {bannersUrl.map((url, index) => (
                  <figure className="w-full h-[160px] relative" key={index}>
                    <img
                      src={url}
                      className="object-cover w-[160px] h-[160px]"
                      alt="merchandise"
                    />
                  </figure>
                ))}
              </div>
            ) : (
              <p>No images</p>
            )}
          </div>
        </div>
      </div>
      <div className="flex mx-auto justify-center my-14">
        <Button.Primary
          disabled={updating || loading}
          title={loading ? <Beat color={"#ffffff"} /> : "Update Store"}
          className={"w-[160px] rounded-sm"}
          onClick={handleSubmit}
        />
      </div>
      {displayCropImage && (
        <ImageCropModal
          show={displayCropImage}
          onClose={closeCropImage}
          width={400}
          height={300}
          images={cropSourceImageFiles}
          getCroppedImages={(cropped) => {
            // Replace the last N items in the images array with cropped versions
            const updated = [...images];
            const start = updated.length - cropSourceImageFiles.length;
            updated.splice(start, cropSourceImageFiles.length, ...cropped);
            setImages(updated);
          }}
        />
      )}
      {displayCropBanner && (
        <ImageCropModal
          show={displayCropBanner}
          onClose={closeCropBanner}
          width={1440}
          height={576}
          images={cropSourceBannerFiles}
          // getCroppedImages={setImages}
          getCroppedImages={(cropped) => {
            // Replace the last N items in the images array with cropped versions
            const updated = [...images];
            const start = updated.length - cropSourceBannerFiles.length;
            updated.splice(start, cropSourceBannerFiles.length, ...cropped);
            setBannerArray(updated);
          }}
        />
      )}
    </div>
  );
}
